import { Link } from "react-router-dom";
import { categories } from "@/mocks/videos";

export default function CategoryNav() {
  const displayCategories = categories.filter((c) => c.slug !== "all");

  const categoryBgImages: Record<string, string> = {
    drama: "https://readdy.ai/api/search-image?query=Chinese%20TV%20drama%20scene%20collage%20with%20warm%20lighting%2C%20modern%20urban%20setting%2C%20emotional%20expressions%2C%20cinematic%20style%2C%20soft%20atmosphere&width=600&height=300&seq=cat-drama&orientation=landscape",
    action: "https://readdy.ai/api/search-image?query=Martial%20arts%20action%20movie%20scene%20with%20dynamic%20movement%2C%20dramatic%20lighting%2C%20intense%20combat%2C%20cinematic%20style%2C%20warm%20color%20tones&width=600&height=300&seq=cat-action&orientation=landscape",
    scifi: "https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20scene%20with%20spaceship%20and%20stars%2C%20deep%20space%20background%2C%20cinematic%20lighting%2C%20sci-fi%20atmosphere%2C%20professional%20movie%20style&width=600&height=300&seq=cat-scifi&orientation=landscape",
    documentary: "https://readdy.ai/api/search-image?query=Nature%20documentary%20scene%20with%20beautiful%20landscape%2C%20wildlife%20in%20natural%20habitat%2C%20warm%20sunlight%2C%20cinematic%20photography%2C%20peaceful%20atmosphere&width=600&height=300&seq=cat-doc&orientation=landscape",
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            分类浏览
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">
            视频分类
          </h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-md mx-auto">
            按类型浏览，快速找到您感兴趣的影视内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {displayCategories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-2xl h-48 cursor-pointer"
            >
              <img
                src={categoryBgImages[cat.slug] || categoryBgImages.drama}
                alt={`${cat.name} - 玫瑰视频`}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-black/20"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-4">
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/20 mb-3 group-hover:bg-primary-500/80 transition-colors duration-300">
                  <i className={`${cat.icon} text-xl text-background-50`}></i>
                </span>
                <h3 className="text-lg font-semibold text-background-50">{cat.name}</h3>
                <p className="text-sm text-background-50/60 mt-1">{cat.count} 部影片</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}